import {BenjiKIVOverlayScatterSymbol} from "../reels/BenjiKIVOverlayScatterSymbol";
import {BenjiKIV} from "../BenjiKIV";

/**
 * Created by Jerker Nord on 2022-12-19.
 */

export class BenjiKIVPoolOverlayScatter {

    private _overlayScatters:BenjiKIVOverlayScatterSymbol[];

    public init():void {
        this._overlayScatters = [];
        for(let i:number = 0; i < 5; i++) {
            this._overlayScatters.push(this.createOverlayScatter());
        }
    }

    private createOverlayScatter():BenjiKIVOverlayScatterSymbol {
        return new BenjiKIVOverlayScatterSymbol();
    }

    public getOverlayScatter():BenjiKIVOverlayScatterSymbol {
        for(let i:number = 0; i < this._overlayScatters.length; i++) {
            if(this._overlayScatters[i].isUsed == false) {
                this._overlayScatters[i].isUsed = true;
                return this._overlayScatters[i];
            }
        }
        //console.log("Creating more Overlay Scatters!");
        this._overlayScatters.push(this.createOverlayScatter());
        return this.getOverlayScatter();
    }

    //Check for overlay on the reel and position and plays noWin if there is
    public playNoWin(reel:number, row:number):void {
        if (BenjiKIV.model.data.overlayScatter.length == 0){
            return;
        }
        for(let i:number = 0; i < this._overlayScatters.length; i++) {
            if(this._overlayScatters[i].isUsed == true && this._overlayScatters[i].isDead == false) {
                if(this._overlayScatters[i].overlayPosition.x == reel && this._overlayScatters[i].overlayPosition.y == (row- 1)) {
                    this._overlayScatters[i].setNoWin();
                }
            }
        }
    }

    public wakeUpOverlayToIdle(reel:number, row:number):void {
        if (BenjiKIV.model.data.overlayScatter.length == 0){
            return;
        }
        for(let i:number = 0; i < this._overlayScatters.length; i++) {
            if(this._overlayScatters[i].isUsed == true && this._overlayScatters[i].isDead == true) {
                if(this._overlayScatters[i].overlayPosition.x == reel && this._overlayScatters[i].overlayPosition.y == (row- 1)) {
                    this._overlayScatters[i].wakeUpToIdle();
                }
            }
        }
    }

    public wakeUpAllOverlaysToIdle():void{
        for(let i:number = 0; i < this._overlayScatters.length; i++) {
            if(this._overlayScatters[i].isUsed == true) {
                this._overlayScatters[i].wakeUpToIdle();
            }
        }
    }

    public getOverlayScatterOnReel(reelId:number):BenjiKIVOverlayScatterSymbol {
        for(let i:number = 0; i < this._overlayScatters.length; i++) {
            if(this._overlayScatters[i].isUsed == true && this._overlayScatters[i].overlayPosition.x == reelId) {
                return this._overlayScatters[i];
            }
        }
        throw new Error("BenjiKIVPoolOverlayScatter: No overlay scatter on that reel!");
    }
}